/** Visual scale for workflow graph node cards relative to the original 280px design. */
export const WORKFLOW_FLOW_NODE_SCALE = 2 / 3;

const BASE_WORKFLOW_NODE_WIDTH = 450;
const BASE_WORKFLOW_NODE_HEIGHT = 190;
const BASE_TRIGGER_NODE_WIDTH = BASE_WORKFLOW_NODE_WIDTH;
const BASE_TRIGGER_NODE_HEIGHT = 160;

export const WORKFLOW_FLOW_NODE_WIDTH = Math.round(
  BASE_WORKFLOW_NODE_WIDTH * WORKFLOW_FLOW_NODE_SCALE
);
export const WORKFLOW_FLOW_NODE_HEIGHT = Math.round(
  BASE_WORKFLOW_NODE_HEIGHT * WORKFLOW_FLOW_NODE_SCALE
);
export const WORKFLOW_FLOW_TRIGGER_WIDTH = Math.round(
  BASE_TRIGGER_NODE_WIDTH * WORKFLOW_FLOW_NODE_SCALE
);
export const WORKFLOW_FLOW_TRIGGER_HEIGHT = Math.round(
  BASE_TRIGGER_NODE_HEIGHT * WORKFLOW_FLOW_NODE_SCALE
);

/**
 * fitView zooms small graphs up to fill the panel — that inflates nodes ~2×.
 * Cap at 1 so cards render at their designed pixel size (matching the reference
 * screenshot). Re-fit via `WorkflowFitView` when the graph changes.
 */
export const WORKFLOW_FLOW_FIT_VIEW_OPTIONS = {
  padding: 0.35,
  maxZoom: 1.2,
} as const;
